import React from "react";
import { Link } from "react-router-dom";

// The support caveat, with the phrase itself pointing at the support page and a
// separate link to what it costs. The wording stays editable in the admin, so the
// phrase is linked only when it is actually in the sentence.
const PHRASE = "paid support package";

export const SupportCaveat = ({ text, className = "", testId = "xero-support-caveat" }) => {
  const sentence = (text || "").trim();
  if (!sentence) return null;
  const i = sentence.toLowerCase().indexOf(PHRASE);

  return (
    <p className={`text-xs text-slate-500 leading-relaxed ${className}`} data-testid={testId}>
      {i === -1 ? (
        sentence
      ) : (
        <>
          {sentence.slice(0, i)}
          <Link to="/services/support" className="font-semibold text-navy hover:text-orange underline decoration-slate-300 underline-offset-2" data-testid="support-caveat-link">
            {sentence.slice(i, i + PHRASE.length)}
          </Link>
          {sentence.slice(i + PHRASE.length)}
        </>
      )}{" "}
      <Link to="/pricing" className="font-semibold text-orange hover:underline" data-testid="support-caveat-price-link">
        See what it costs
      </Link>
      .
    </p>
  );
};

export default SupportCaveat;
